<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/WkqQOf/tc-custom/Cover.jpg" />
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Feathers
      </h1>
      <p class="bookDescription body article font2">
        <p>Born covered in black feathers, abandoned as a baby in the slums of the Maze, Poe has lived his entire 11-year-old life hidden away under the protection of his adoptive father, Gabriel. He spends his days secretly helping the Mice, bands of orphans who roam the slums, but there is a whisper of an altogether more sinister figure in the shadows, making street children disappear. When Bianca, an over-protected girl from the wealthy City beyond the Wall, escapes into the Maze in search of adventure, their worlds collide. Collects the complete six-issue limited series plus never-before-seen artwork.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jorge Corona
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      BOOM! Studios
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?bf05a582